import React, { useEffect, useState } from 'react'
import { Link, useNavigate,useLocation } from "react-router-dom";
import TeamTable from './TeamTable';
import { BiArrowBack } from 'react-icons/bi';
import { Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextareaAutosize } from '@mui/material';
import DeactivateModal from '../../Common/DeactivateMemberModal';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { SpinLoader } from '../ImportCandidates';
import RequestedProfileTable from './RequestedProfileTable';
import { useSelector, useDispatch } from "react-redux";
import Pagination from "../../Common/Pagination/Pagination";
import { InvitationsAction } from '../../../Redux/action/InvitationsAction';
import { RequestAction } from '../../../Redux/action/RequestedAction';



const RequestedProfile = () => {
    const dispatch = useDispatch();

    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason
    const [otherReason, setOtherReason] = useState(""); // To store the custom reason text
    const [showOtherTextarea, setShowOtherTextarea] = useState(selectedReason === "other");
    const [loading, setLoading] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [pageNumber, setPageNumber] = useState(0);

    const location = useLocation();
    const { pathname } = useLocation();
    const queryParams = new URLSearchParams(location?.search);
    const vId = queryParams.get('vendorId');
    const baseUrl = process.env.REACT_APP_API_PATH;
    const { userResult } = useSelector((state) => state.Auth);
    let vendorId = vId ? vId : userResult?.vendorid;

    const aadhaar= useSelector((state) => state.Profile.result?.aadharCardNumber)

    const userInfoInvitation = useSelector((state) => state?.InvitationsReducer?.result?.content);
    const totalPagesInvitation = useSelector((state) => state?.InvitationsReducer?.result?.totalPages);

  
    const userInfoRequest = useSelector((state) => state?.RequestReducer?.result?.content);
    const totalPagesRequest = useSelector((state) => state?.RequestReducer?.result?.totalPages);
   


   

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const handlePageChange = (page) => {
        setPageNumber(page);
        // You can also fetch data for the new page here or update your component state accordingly
      };

    const buttonStyles = {
        padding: "8px",
        background: selectedCandidates.length > 0 ? "rgba(28, 101, 151, 0.57)" : "#286a94",
        color: "#fff",
        fontSize:'13px'
    };


    const handleReasonChange = (event) => {
        const value = event.target.value;
        setSelectedReason(value);

        // If "other" is selected, show the textarea
        setShowOtherTextarea(value === "other");
    };

    const handleOtherReasonChange = (event) => {
        setOtherReason(event.target.value);
    };

    // console.log('---->', otherReason)

    const handleSubmit = async (e) => {
        setLoading(true)
        try {
            const content = {
                reason: selectedReason !== 'other' ? selectedReason : otherReason,
                candidateId: selectedCandidates,
                vendorId
            }
            const response = await axios.put(`${baseUrl}/ebench/deactivate_team_member`, content, {
                headers: {
                    "Content-Type": "application/json",
                },
            })

            const data = await response.data;

            setLoading(false)
            setSelectedReason("")
            setSelectedCandidates([])
            closeModal();
            setComponentKey((prevKey) => prevKey + 1);
        } catch (error) {
            setLoading(false)
            console.error("Error occurred", error);
            toast.error(error.response.data.status.message);
        }

    }

    useEffect(() => {
       
        if(pathname==="/invitations"){ 
            let content ={
                aadhaar,
                pageNumber
            }
            dispatch(InvitationsAction(content))
        }else{
            let content ={
                vendorId,
                pageNumber
            }
            dispatch(RequestAction(content))
        }
        
       
    }, [pathname, aadhaar, vendorId, pageNumber, dispatch])

    

    const navigate = useNavigate();
    return (

        <>
            <ToastContainer />
            <div key={componentKey}>


            {pathname === "/invitations" ? (
                    <>
                        <div className="">
                            <RequestedProfileTable pathname={pathname} interviewList={userInfoInvitation} />
                        </div>
                        {
                            userInfoInvitation?.length>0 &&
                            <Pagination
                                totalPages={totalPagesInvitation}
                                currentPage={pageNumber}
                                onPageChange={handlePageChange}
                            />
                        }
                        
                    </>
                ) : (
                    <>
                        <div className="">
                            <RequestedProfileTable pathname={pathname} interviewList={userInfoRequest} />
                        </div>
                        {
                            userInfoRequest?.length>1 &&
                        <Pagination
                            totalPages={totalPagesRequest}
                            currentPage={pageNumber}
                            onPageChange={handlePageChange}
                        />
                        }
                        
                    </>
                    
                )}


            </div>
           
        </>
    )
}

export default RequestedProfile